import { Directive } from '@angular/core';

@Directive({
  selector: '[dialogActions], dialogActions',
  standalone: true,
  host: {
    class: 'tt-common-dialog_actions',
  },
})
export class DialogActionsDirective {}
